import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Brisa',
  logo: { name: 'Brisa', src: '/logo/brisacard.png' },
  portrait: { src: '/photo/portrait-filiz-mert.png', alt: 'Filiz Mert' },
  quote: [
    'We have been renewing the digital transformation solution on a regular basis for 3 '
    + 'years. This year, we plan to include more Digital Maturity Index (DMI) assessment '
    + 'results in our action plan by pulling this study earlier in order to evaluate DMI '
    + 'outputs and determine company strategies according to these outputs at our strategy '
    + 'meeting. We will continue to renew DMI to keep seeing where our strengths lie and '
    + 'also the muscles we need to strengthen, and what we have achieved in the last 3 years '
    + 'in our digital transformation journey.',
  ],
  attribution: 'Filiz Mert, Digital Projects & Analytics Manager',
  story: 'brisa',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 11
